(function () {
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.style.display === 'flex';
      mnav.style.display = open ? 'none' : 'flex';
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mnav.style.display = 'none'; });
    });
  }
})();
